import { Link } from 'react-router-dom'

import { BrandMark } from '@/components/visuals'
import { ROUTES, SITE } from '@/config/site'
import { useI18n } from '@/i18n'
import { cn } from '@/lib/cn'

/** Header/footer identity: the brand mark plus the wordmark. */
export function Wordmark({ size = 'sm' }: { size?: 'sm' | 'lg' }) {
  const { t } = useI18n()

  return (
    <Link to={ROUTES.home} className="flex items-center gap-3">
      {/* No glow at this scale — it smudges the fine rays into a blob. */}
      <BrandMark
        glow={false}
        priority
        className={cn('shrink-0', size === 'lg' ? 'w-12' : 'w-10')}
      />
      <span className="leading-tight">
        <span
          className={cn(
            'block font-serif tracking-[0.14em] text-gold',
            size === 'lg' ? 'text-xl' : 'text-base sm:text-lg',
          )}
        >
          {SITE.name}
        </span>
        <span
          className={cn(
            'text-[0.625rem] uppercase tracking-[0.2em] text-faint',
            size === 'lg' ? 'block' : 'hidden sm:block',
          )}
        >
          {t.footer.tagline}
        </span>
      </span>
    </Link>
  )
}
